module.exports = __webpack_public_path__ + "static/media/USD.6814e96a.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/USD.png
// module id = 61
// module chunks = 0